var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"50vh","max-height":"415px","display":"block"},attrs:{"id":"threeContainer"}},[_c('canvas')])}]

export { render, staticRenderFns }